import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 400px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: ${props => props.highlight ? 'linear-gradient(135deg, var(--glass-1), rgba(6,182,212,0.15))' : 'var(--glass-1)'};
  border: ${props => props.highlight ? '2px solid var(--accent)' : '1px solid var(--glass-border)'};
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: ${props => props.highlight ? '0 10px 40px rgba(6,182,212,0.2)' : '0 5px 20px rgba(0,0,0,0.1)'};
  backdrop-filter: blur(10px);
`;

const Badge = styled.div`
  position: absolute;
  top: 15px;
  right: -35px;
  background: var(--accent);
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 5px 40px;
  transform: rotate(45deg);
  box-shadow: 0 5px 10px var(--accent-glow);
`;

const Title = styled.h3`
  margin: 0 0 10px 0;
  color: var(--text-primary);
  font-size: 22px;
`;

const Price = styled.div`
  font-size: 48px;
  font-weight: 900;
  color: ${props => props.highlight ? 'var(--accent)' : 'var(--text-primary)'};
  margin: 20px 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  span {
    font-size: 16px;
    margin-top: 10px;
    margin-left: 5px;
    color: var(--text-muted);
    font-weight: normal;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
  text-align: left;

  li {
    padding: 10px 0;
    border-bottom: 1px solid var(--glass-border);
    color: var(--text-secondary);
    font-size: 14px;
    display: flex;
    align-items: center;

    &::before {
      content: '✓';
      color: var(--accent);
      font-weight: bold;
      margin-right: 10px;
      font-size: 16px;
    }
  }
`;

const Button = styled.button`
  width: 100%;
  background: ${props => props.highlight ? 'linear-gradient(135deg, var(--accent), var(--accent-neon))' : 'var(--glass-2)'};
  color: ${props => props.highlight ? '#fff' : 'var(--text-primary)'};
  border: ${props => props.highlight ? 'none' : '1px solid var(--glass-border)'};
  padding: 15px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: ${props => props.highlight ? '0 5px 15px var(--accent-glow)' : '0 0 10px rgba(255,255,255,0.1)'};
    background: ${props => !props.highlight && 'rgba(255,255,255,0.1)'};
  }
`;

const PricingPlanWidget = ({ node }) => {
  const isHighlight = node.style?.desktop?.highlight;

  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width} highlight={isHighlight}>
      {isHighlight && <Badge>Bestseller</Badge>}
      <Title>{node.content?.title || 'O2 Mobile M'}</Title>
      <div style={{ color: 'var(--text-muted)', fontSize: '14px' }}>{node.content?.desc || 'Der perfekte Allrounder'}</div>
      
      <Price highlight={isHighlight}>
        29,99<span>€/Monat</span>
      </Price>
      
      <FeatureList>
        <li>25 GB+ Highspeed-Daten</li>
        <li>Jedes Jahr 5 GB monatlich mehr</li>
        <li>4G LTE / 5G Netz</li>
        <li>Allnet-Flat Telefonie & SMS</li>
      </FeatureList>

      <Button highlight={isHighlight} className={isHighlight ? 'tef-bubbles' : ''}>
        Jetzt auswählen
      </Button>
    </Wrapper>
  );
};

registry.register('pricing_plan', {
  label: 'Preistabelle',
  icon: '💳',
  category: 'advanced',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%', highlight: false } },
  render: PricingPlanWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Inhalte', fields: [{name:'content.title', label:'Tarif-Name', type:'text'}, {name:'content.desc', label:'Beschreibung', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Konfiguration', fields: [{name:'style.desktop.highlight', label:'Hervorheben (Bestseller)', type:'checkbox'}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Max Breite', type:'text'}] }] }
  ]
});
